import { AppIcon, type IconName } from './AppIcon';

export function EmptyState({ icon, title, children }: { icon: IconName; title: string; children?: React.ReactNode }) {
  return <div className="empty-state"><div className="empty-state-icon"><AppIcon name={icon}/></div><h3>{title}</h3>{children && <p>{children}</p>}</div>;
}
